export type TronParameters = { type: string; value: string | TronParameters }[];
